/**
 * @fileoverview App.js - main application wrapper.
 * 
 * This module is the outer application wrapper.
 * 
 * @module App.js
 * @version 1.0.0
 * @author Mark Pearce
 * @license Proprietary
 * 
 * Copyright (c) 2025 Silkstone Technology Limited. All rights reserved.
 * 
 * This software is proprietary and confidential. You are not permitted to:
 * - Use, copy, modify, or distribute this software, in whole or in part, without 
 *   written permission from the author or rights holder.
 * - Reverse engineer, decompile, or disassemble the software.
 * - License, sublicense, or otherwise distribute the software without the express 
 *   written consent of the copyright holder.
 * 
 * This software is provided "as-is," without any express or implied warranty. The copyright 
 * holder is not liable for any damage or loss arising from the use of this software.
 * 
 * @requires 
 * 
 * @example
 */

import 'bootstrap/dist/css/bootstrap.min.css';

import './App.css';
import { BrowserRouter as Router, 
         Route, 
         Routes }  from 'react-router-dom';

// Import Required routes for the router.
import AdminOptions  from './components/AdminOptions'; 
import AdminUsers    from './components/AdminUsers'; 
import AdminSystem   from './components/AdminSystem'; 
import HomePage      from './components/HomePage';
import Navigation    from './components/Navigation';
import SignUp        from './components/SignUp';
import Verify        from './components/Verify';
import Status        from './components/Status';
import AddGoal       from './components/AddGoal';
import UpdateGoal    from './components/UpdateGoal';
import EditGoal      from './components/EditGoal';
import ReviewGoal    from './components/ReviewGoal';
import Profile       from './components/Profile';

function App() {
  return (
        <Router>
            <Navigation />
            <Routes>
                <Route path="/"              element={<HomePage />} />
                <Route path="/admin-options" element={<AdminOptions />} />
                <Route path="/admin-users"   element={<AdminUsers />} />
                <Route path="/admin-system"  element={<AdminSystem />} />
                <Route path="/home"          element={<HomePage />} />
                <Route path="/signup"        element={<SignUp />} />
                <Route path="/verify"        element={<Verify />} />
                <Route path="/status"        element={<Status />} />
                <Route path="/add-goal"      element={<AddGoal />} />
                <Route path="/update-goal"   element={<UpdateGoal />} />
                <Route path="/edit-goal"     element={<EditGoal />} />
                <Route path="/review-goal"   element={<ReviewGoal />} />
                <Route path="/profile"       element={<Profile />} />
            </Routes>
        </Router>  );
}

export default App;
